'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'face-glasses';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e377';
var svgPathData = 'M288 480c92.5 0 171.9-56 206.1-136l34.4 0c-35.9 98-130 168-240.5 168S83.4 442 47.5 344l34.4 0C116.1 424 195.5 480 288 480zm0-448c-47.5 0-91.5 14.8-127.8 40L110 72C156.1 27.4 218.8 0 288 0S419.9 27.4 466 72l-50.2 0C379.5 46.8 335.5 32 288 32zm0 352c42.6 0 80.3-20.8 103.6-52.8L417.5 350c-29.1 40-76.2 66-129.5 66s-100.5-26-129.5-66l25.9-18.8c23.3 32.1 61 52.8 103.6 52.8zM168 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-80-72l224 0 0 48 32 0 0 32-32 0 0 112-224 0 0-120-32 0 0 120-224 0 0-112-32 0 0-32 32 0 0-48 224 0 0 40 32 0 0-40zm192 80l0-48-160 0 0 128 160 0 0-80zM80 272l160 0 0-128-160 0 0 128z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceGlasses = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;